// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"13":"c506a406f642ae6d","99":"80fef608b3385a53","572":"70006b9f5678ca80","758":"8801f3484a21f288"}[chunkId] + ".js";
};